var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "intercomFot"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "userId"
  }, [_c('span', {
    staticClass: "userIdText"
  }, [_vm._v(_vm._s(_vm.$t('intercom.userId')))]), _vm.hasClickRename ? _c('el-input', {
    ref: "nickNameInput",
    staticClass: "renameInput",
    on: {
      "blur": function ($event) {
        return _vm.saveNickname();
      },
      "change": function ($event) {
        return _vm.saveNickname();
      }
    },
    model: {
      value: _vm.nickNameInputVal,
      callback: function ($$v) {
        _vm.nickNameInputVal = $$v;
      },
      expression: "nickNameInputVal"
    }
  }) : _vm._e(), _c('el-popover', {
    attrs: {
      "popper-class": "IDTips"
    },
    model: {
      value: _vm.showPopover,
      callback: function ($$v) {
        _vm.showPopover = $$v;
      },
      expression: "showPopover"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasClickRename,
      expression: "!hasClickRename"
    }],
    staticClass: "userIdNum pointer",
    attrs: {
      "slot": "reference",
      "title": _vm.rtilCode
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.nickName || _vm.rtilCode))]), _c('div', {
    staticClass: "nameBox"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "renameBox"
  }, [_c('p', {
    staticClass: "renameText",
    on: {
      "click": function ($event) {
        return _vm.showRenameInput();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pushTalk.rename')))])]), _c('el-divider', {
    staticClass: "gray"
  }), _c('p', {
    staticClass: "copyId",
    on: {
      "click": function ($event) {
        return _vm.copyUserId();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('intercom.copyUserId')) + " ")])], 1)])])])], 1)]), _c('div', {
    staticClass: "center"
  }, [_vm.$route.name == 'intercom' ? _c('span', {
    staticClass: "talkToAllTalents",
    class: {
      active: _vm.State.intercomTalkToAllTalents,
      disabled: !_vm.talentList.length
    },
    on: {
      "click": function ($event) {
        return _vm.controlTalkToAllTalents(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('intercom.talkToAllTalents')) + " "), _c('div'), _c('div')]) : _vm._e(), _vm.$route.name == 'station' ? _c('span', {
    staticClass: "pushToHost",
    class: {
      active: _vm.State.intercomTalkToHost,
      disabled: !_vm.selectSessionInfo.intercomSessionId
    },
    on: {
      "click": function ($event) {
        return _vm.controlTalkToHost(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('intercom.pushToHost')) + " "), _c('div'), _c('div')]) : _vm._e()]), _c('div', {
    staticClass: "contentRight"
  }, [_c('div', {
    staticClass: "devicesControl"
  }, [_c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('audioCheck', {
    attrs: {
      "mic": _vm.mic,
      "microphoneId": _vm.devicesInfo.microphoneId,
      "devicesInfo": _vm.devicesInfo,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc
    },
    on: {
      "callback": _vm.controlAudio
    }
  }), _vm.rtcLoaded && _vm.microphoneDevice.length ? _c('device-select', {
    attrs: {
      "title": _vm.$t('operationBtn.selectMicrophone'),
      "type": "audio",
      "deviceSelectId": _vm.devicesInfo.microphoneId,
      "data": _vm.microphoneDevice,
      "rtilCode": _vm.rtilCode
    },
    on: {
      "changeDevice": _vm.changeDevice,
      "updateDeviceId": _vm.updateDeviceId,
      "showAudioSetting": _vm.showAudioSetting
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "deviceIconBox"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.turnTips(!_vm.speaker, _vm.$t('operationBtn.speaker')),
      "placement": "top"
    }
  }, [_vm.speaker ? _c('i', {
    staticClass: "iconfont icon-a-V2speakeron",
    on: {
      "click": function ($event) {
        return _vm.controlSpeaker(false);
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2speakeroff",
    on: {
      "click": function ($event) {
        return _vm.controlSpeaker(true);
      }
    }
  })]), _vm.rtcLoaded && _vm.speakerDevice.length ? _c('device-select', {
    attrs: {
      "title": _vm.$t('operationBtn.selectSpeaker'),
      "type": "speaker",
      "deviceSelectId": _vm.devicesInfo.speakerId,
      "data": _vm.speakerDevice,
      "rtilCode": _vm.rtilCode
    },
    on: {
      "changeDevice": _vm.changeDevice,
      "updateDeviceId": _vm.updateDeviceId
    }
  }) : _vm._e()], 1)])]), _c('tipsDailog', {
    staticClass: "audioSettingDailog",
    attrs: {
      "info": _vm.audiSettingInfo
    },
    on: {
      "cancel": function ($event) {
        return _vm.setAduioSetting('cancel');
      },
      "save": function ($event) {
        return _vm.setAduioSetting('save');
      }
    }
  }, _vm._l(_vm.audioSettingList, function (item) {
    return _c('div', {
      key: item.type,
      staticClass: "settingLi"
    }, [_c('el-checkbox', {
      staticClass: "greenStyle",
      model: {
        value: item.checked,
        callback: function ($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    }), _c('span', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.type))]), _c('span', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(_vm.$t(`${item.i18n}`)))])], 1);
  }), 0)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };